import { render } from "./AdminEditStatus.vue?vue&type=template&id=62432a88&lang=pug"
import script from "./AdminEditStatus.vue?vue&type=script&lang=js"
export * from "./AdminEditStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__